import { Box, Icon, Tooltip } from '@dixa/lib-shared-habla';

import { getMessageWithColor } from './getMessageWithColor';

type Props = {
  /** Is user verified by us. */
  isVerifiedUser: boolean;
};

/** Display the Messenger authentication level for the conversation. */
export const MessengerAuthenticationLevel = ({
  isVerifiedUser,
}: Props): JSX.Element => {
  const { message, color } = getMessageWithColor(isVerifiedUser);

  return (
    <Box margin="200 0 0 100">
      <Tooltip wrap="div" content={message}>
        <Icon name="shield-alert" color={color} />
      </Tooltip>
    </Box>
  );
};
